import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const ContactInfo = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      {/* Contact Information Card */}
      <div className="bg-card rounded-lg shadow-elevation-md p-6 lg:p-8">
        <h2 className="font-heading text-2xl font-bold text-primary mb-6">
          {t('contact.info.title')}
        </h2>

        <div className="space-y-6">
          {/* Phone */}
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon name="PhoneIcon" size={24} variant="outline" className="text-accent" />
            </div>
            <div>
              <h3 className="font-body text-sm font-semibold text-foreground mb-1">
                {t('contact.info.phone')}
              </h3>
              <div className="space-y-1">
                <a href="tel:+4963598676" className="block text-base text-muted-foreground hover:text-accent transition-smooth">
                  +49 (0) 6359 86762
                </a>
                <a href="tel:+491722973022" className="block text-base text-muted-foreground hover:text-accent transition-smooth">
                  +49 (0) 172 297 30 22
                </a>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon name="EnvelopeIcon" size={24} variant="outline" className="text-accent" />
            </div>
            <div>
              <h3 className="font-body text-sm font-semibold text-foreground mb-1">
                {t('contact.info.email')}
              </h3>
              <a href="mailto:info@golddreams.eu" className="text-base text-muted-foreground hover:text-accent transition-smooth">
                info@golddreams.eu
              </a>
            </div>
          </div>

          {/* Address */}
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon name="MapPinIcon" size={24} variant="outline" className="text-accent" />
            </div>
            <div>
              <h3 className="font-body text-sm font-semibold text-foreground mb-1">
                {t('contact.info.address')}
              </h3>
              <p className="text-base text-muted-foreground">
                Peterskopfstr. 2<br />
                67269 Grünstadt<br />
                Deutschland
              </p>
            </div>
          </div>

          {/* Business Hours */}
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon name="ClockIcon" size={24} variant="outline" className="text-accent" />
            </div>
            <div>
              <h3 className="font-body text-sm font-semibold text-foreground mb-1">
                {t('contact.info.hours')}
              </h3>
              <p className="text-base text-muted-foreground">
                {t('contact.info.hoursValue')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;